/**
 * Form to input parameters and constraints based on which test cases are generated in the ctd tool
 * @param {object} parameters
 * @param {function} setParameters
 * @param {object} generatedTests
 * @param {function} errorDisplay
 */
import Styles from './Analysis.module.scss'
import { useContext } from 'react';

// module imports
import axios from 'axios';

// component imports
import { ViewContext } from 'components/lib';
import { useTranslation } from 'components/lib';
import { Chart } from 'components/lib';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import FeatherIcon from 'feather-icons-react';

function ParaTag({ head, value }) {
    return (
        <p style={{ fontWeight: 600 }}>{head}: <span style={{ fontWeight: 'normal' }}>{value}</span></p>
    )
}

export function Analysis({ parameters, setParameters, generatedTests, errorDisplay, resource }) {

    const viewContext = useContext(ViewContext)
    const { t } = useTranslation();
    const endPoint = resource ? 'api/labs/pict' : 'api/pict'
    function handleAnalyze() {
        //send the parameters nad generated tests to the server to analyze the coverage of the generated test cases
        if (!generatedTests) {
            errorDisplay(t('Components.NodeLayout.CombinatorialTestPane.analysis.error.generateTests'))
            return;
        }

        axios.post(`${endPoint}/analyze`, { coverage: parameters.coverage, genTests: generatedTests.cases })
            .then((response) => {
                setParameters(prevState => {
                    return {
                        ...prevState,
                        analytics: response.data.data
                    }
                })
            })
            .catch((error) => {
                viewContext.handleError(error);
            })
    }
    return (
        <div className={Styles.parentContainer_analysis}>
            <div className={Styles.header}>
                <p>{t('Components.NodeLayout.CombinatorialTestPane.analysis.header')}</p>
                <AivagamButton
                    buttonText={
                        <div style={{ display: 'flex', gap: '0.5em', height: '1em', alignItems: 'center' }}>
                            <FeatherIcon size='1.5em' icon='bar-chart-2' />
                            {t('Components.NodeLayout.CombinatorialTestPane.analysis.button.analyze')} </div>
                    }
                    onClick={handleAnalyze}
                    classStyles={{ height: 'fit-content' }}
                    type='action'
                />
            </div>
            <div className={Styles.analysis_body}>
                {parameters?.analytics &&
                    <>
                        <p>{t('Components.NodeLayout.CombinatorialTestPane.analysis.analytics.header', { coverage: `${parameters.analytics.coverage}-wise` })}</p>
                        <ParaTag head={t('Components.NodeLayout.CombinatorialTestPane.analysis.analytics.tests')} value={generatedTests.cases.length} />
                        <ParaTag head={t('Components.NodeLayout.CombinatorialTestPane.analysis.analytics.possibleTests')} value={parameters.analytics.possible_tests} />
                        <ParaTag head={t('Components.NodeLayout.CombinatorialTestPane.analysis.analytics.coverage')} value={`${(parameters.analytics.covered_comb / parameters.analytics.total_combination) * 100}%`} />
                        <span className={Styles.validComb}>
                            <ParaTag head={parameters.analytics.coverage === 1 ? t('Components.NodeLayout.CombinatorialTestPane.analysis.analytics.singleValues') : t('Components.NodeLayout.CombinatorialTestPane.analysis.analytics.validCombinations', { combinations: parameters.analytics.coverage })} />
                            <ul className={Styles.combList}>
                                <li><ParaTag head={t('Components.NodeLayout.CombinatorialTestPane.analysis.analytics.total')} value={parameters.analytics.total_combination} /></li>
                                <li><ParaTag head={t('Components.NodeLayout.CombinatorialTestPane.analysis.analytics.covered')} value={parameters.analytics.covered_comb} /></li>
                                <li><ParaTag head={t('Components.NodeLayout.CombinatorialTestPane.analysis.analytics.uncovered')} value={parameters.analytics.total_combination - parameters.analytics.covered_comb} /></li>
                            </ul>
                        </span>
                        <ParaTag head={t('Components.NodeLayout.CombinatorialTestPane.analysis.analytics.accumulatedCoverage')} />
                        <span className={Styles.coverageChart}>
                            <Chart
                                type='line'
                                data={parameters.analytics.chart_data}
                                legend={true}
                            />
                        </span>
                    </>
                }
            </div>
        </div>
    )
}
